var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxTik(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07893 0.243989C8.23515 0.400262 8.32292 0.612185 8.32292 0.833155C8.32292 1.05413 8.23515 1.26605 8.07893 1.42232L3.91226 5.58899C3.75599 5.74521 3.54406 5.83298 3.32309 5.83298C3.10212 5.83298 2.8902 5.74521 2.73393 5.58899L0.233926 3.08899C0.0821281 2.93182 -0.00186718 2.72132 3.15022e-05 2.50282C0.00193018 2.28432 0.089571 2.07531 0.244078 1.92081C0.398584 1.7663 0.607595 1.67866 0.826092 1.67676C1.04459 1.67486 1.25509 1.75886 1.41226 1.91066L3.32309 3.82149L6.90059 0.243989C7.05687 0.0877629 7.26879 0 7.48976 0C7.71073 0 7.92265 0.0877629 8.07893 0.243989Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxTik);
export default __webpack_public_path__ + "static/media/checkbox_tik.118a8d83d6f4d22ae1ebaae8ca0f8f5d.svg";
export { ForwardRef as ReactComponent };